<div class="padding">
  <div class="box card-box shadow templateList">
    <div class="box-header">
      <div class="col-md-6 col-sm-6 p-a-0">
        <h3>{{ 'TEMPLATE.templates' | translate }}</h3>
      </div>
      <div class="col-md-6 col-sm-6 p-a-0 flex-end">
        <button (click)="clearAllFilters()"
                [disabled]="!isFiltering()"
                class="btn btn-sm btn-outline-primary m-x-sm clear-filter">
          {{ 'CONTEXT_BAR.clear_all_filters' | translate }}
        </button>
        <div [userRoles]="['EGEN_DOC_WRITE']" gp-roles>
          <button (click)="openCreateTemplateModal()" class="btn btn-sm btn-primary md-flat pull-right m-x-sm"
                  test-id="new-template">
            <em class="fa fa-light fa-plus-circle"></em>
            {{ 'TEMPLATE.new_template' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="box-body p-l-sm p-r-xs">
      <table aria-describedby="templateList"
             class="table table-striped gp-table default-cursor templateList"
             id="template-list">
        <thead class="template-table--header" gp-table-head>
        <tr class="text-uppercase">
          <th class="text-sm min-width-sm p-y-0" gp-table-column
              scope="col"
              test-id="templateName-header">
            {{ 'FORMS.name' | translate }}
          </th>
          <th class="text-sm p-y-0"
              gp-table-column
              scope="col"
              test-id="folder-header">
            {{ 'TEMPLATE.folder' | translate }}
          </th>
          <th class="text-sm p-y-0"
              scope="col"
              test-id="regulation-header">
            {{ 'COMMON.regulation' | translate }}
          </th>
          <th class="text-sm p-y-0"
              gp-table-column
              scope="col"
              test-id="language-header">
            {{ 'SIGNIN.language' | translate }}
          </th>
          <th class="text-sm p-y-0"
              gp-table-column
              scope="col"
              test-id="created-by">
            {{ 'TEMPLATE.created_by' | translate }}
          </th>
          <th class="text-sm w-sm p-y-0"
              gp-table-column
              scope="col"
              test-id="updated-date">
            {{ 'TEMPLATE.updated_date' | translate }}
          </th>
          <th class="text-sm p-y-0" scope="col" test-id="availability-header">
            {{ 'TEMPLATE.availability' | translate }}
          </th>
          <th *ngIf="signatureEnabled" class="text-sm p-y-0" scope="col" test-id="signatures-header">
            {{ 'TEMPLATE.signatures' | translate }}
          </th>
          <th class="text-sm w-sm p-y-0" gp-table-column scope="col" test-id="status-header">
            {{ 'COMMON.status' | translate }}
          </th>
          <th class="p-y-0 w-50" scope="col"></th>
        </tr>
        <tr [formGroup]="filtersForm" class="row filters" role="row">
          <td>
            <input [attr.test-id]="'reportNameFilter'"
                   class="form-control w-170"
                   formControlName="name"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text"/>
          </td>
          <td>
            <input [attr.test-id]="'folderNameFilter'"
                   class="form-control w-70"
                   formControlName="folder"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text"/>
          </td>
          <td>
            <gp-tree-select
              (elementSelected)="onRegulationSelected($event)"
              [attr.test-id]="'regulationFilter'"
              [isSorted]="true"
              [placeholder]="'NAVBAR.search' | translate"
              [tree]="regulationTree"
              formControlName="regulation"
              ngDefaultControl
              class="form-control w-128 text-ellipsis">
            </gp-tree-select>
          </td>
          <td>
            <input [attr.test-id]="'languageFilter'"
                   class="form-control w-xs"
                   formControlName="locale"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text"/>
          </td>
          <td>
            <input [attr.test-id]="'createdByFilter'"
                   class="form-control w-170"
                   formControlName="createdBy"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text"/>
          </td>
          <td class="w-150">
            <datepicker-input
              [attr.test-id]="'updatedDateFilter'"
              [hasEternity]="true"
              [isAppendToBody]="false"
              class="compact w-150"
              formControlName="date"
              ngDefaultControl>
            </datepicker-input>
          </td>
          <td>
                <span class="text-sm btn-status-availability"
                      test-id="availabilityHeading">{{ 'TEMPLATE.hr' | translate }}</span>
          </td>
          <td *ngIf="signatureEnabled"></td>
          <td class="w-sm">
            <gp-tree-multi-select (selectedChange)="onStatusSelected($event)"
                                  *ngIf="statusTree.length"
                                  [attr.test-id]="'status-select' | gpTestId: 'templates'"
                                  [config]="treeConfig"
                                  [isSorted]="true"
                                  [items]="statusTree">
            </gp-tree-multi-select>
          </td>
          <td class="w-50"></td>
        </tr>
        </thead>
        <tbody class="fade-in-right">
        <tr *ngIf="loading">
          <td class="text-center p-t-lg p-b-lg" colspan="10">
            <em class="fa fa-light fa-spinner fa-spin"></em>
          </td>
        </tr>
        <ng-container *ngIf="!loading && templates?.length">
          <tr
            (click)="(template?.status == 'DRAFT' || template?.status == 'UNPUBLISHED') && onTemplateRowClick(template?.id, $event)"
            *ngFor="let template of templates trackBy: trackByTemplateId"
            [class.highlight]="template.id === newlyCreatedTemplateId"
            [ngClass]="{'pointer': template?.status == 'DRAFT' || template?.status == 'UNPUBLISHED'}">
            <td class="wrap align-cell" test-id="template-name">
              <span>{{ template.name }}</span>
            </td>
            <td [attr.title]="template?.folder" [innerHTML]="template?.folder" class="w-xs text-ellipsis"
                test-id="template-folder"></td>
            <td class="align-cell" test-id="template-cliRegName">{{ template.cliRegName }}</td>
            <td class="align-cell" test-id="template-locale">{{ template.locale }}</td>
            <td class="align-cell" test-id="template-created-by">{{ template?.createdBy }}</td>
            <td class="align-cell"
                test-id="template-updated-date"> {{ template?.updatedDate | gpDate: {withHour: true} : (trigger$|async) }}
            </td>
            <td class="align-cell" testi-id="template-availability">
              <div class="availability-status">
                    <span>
                      <i
                        [attr.test-id]="'template-availability-types'"
                        [ngClass]="isAvailabilityChecked('HR_PRO', template.availability) ? 'fa-check' : 'fa-minus not-available'"
                        aria-hidden="true"
                        class="fa fa-light p-a-xs">
                      </i>
                    </span>
              </div>
            </td>
            <td *ngIf="signatureEnabled" class="align-cell" test-id="template-signatures">
              <div class="availability-status">
                <span>
                  <i
                    [attr.test-id]="'template-signatures-icon'"
                    [ngClass]="hasSignatureData(template) ? 'fa-check' : 'fa-minus not-available'"
                    aria-hidden="true"
                    class="fa fa-light p-a-xs">
                  </i>
                </span>
              </div>
            </td>
            <td class="align-cell" test-id="template-status">
              <ng-container [ngSwitch]="template?.status">
                <div *ngSwitchCase="'DRAFT'"
                     class="status status-draft w-m text-center">
                  <em class="fa fa-light fa-pencil-alt"></em>
                  <span>{{ 'DOCUMENTS.draft' | translate | uppercase }}</span>
                </div>
                <div *ngSwitchCase="'PUBLISHED'"
                     class="status status-validated w-m text-center">
                  <em class="fa fa-light fa-check-circle"></em>
                  <span>{{ 'TEMPLATE.published' | translate | uppercase }}</span>
                </div>
                <div *ngSwitchCase="'UNPUBLISHED'"
                     class="status status-pending w-m text-center">
                  <em class="fa fa-light fa-exclamation-circle"></em>
                  <span>{{ 'TEMPLATE.unpublished' | translate | uppercase }}</span>
                </div>
              </ng-container>
            </td>
            <td *ngIf="{ opened: false } as contextMenu" class="w-50" test-id="template-actions">
              <div (click-outside)="contextMenu.opened = false"
                   [class.open]="contextMenu.opened"
                   class="dropdown">
                <button (click)="contextMenu.opened = !contextMenu.opened"
                        class="btn btn-outline btn-xs btn-context-menu"
                        type="button">
                  <span class="fa fa-light fa-ellipsis-v"></span>
                </button>
                <ul (click)="contextMenu.opened = false"
                    *ngIf="contextMenu.opened"
                    class="dropdown-menu pull-right dropdown-menu-scale">
                  <ng-template [ngIfElse]="notPublishedContextMenu" [ngIf]="template?.status == 'PUBLISHED'">
                    <li class="dropdown-item disabled" test-id="action-edit-item">
                      <i aria-hidden="true" class="fa fa-light fa-cog dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.settings' | translate }}</span>
                    </li>
                    <li class="dropdown-item disabled" test-id="action-modify-template">
                      <i aria-hidden="true" class="fa fa-light fa-file-alt dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.edit' | translate }}</span>
                    </li>
                    <li (click)="openDuplicateETemplateModal(template)" class="dropdown-item"
                        test-id="action-duplicate-template">
                      <i aria-hidden="true" class="fa fa-light fa-copy dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.duplicate' | translate }}</span>
                    </li>
                    <li (click)="openPublishETemplateModal(template)" class="dropdown-item"
                        test-id="action-publish-template">
                      <i aria-hidden="true" class="fa fa-light fa-cloud-download-alt dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.unpublish' | translate }}</span>
                    </li>
                    <li class="dropdown-item disabled" test-id="action-delete-template">
                      <i aria-hidden="true" class="fa fa-light fa-trash-alt dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.delete' | translate }}</span>
                    </li>
                  </ng-template>
                  <ng-template #notPublishedContextMenu>
                    <li (click)="openEditItemModal(template)" class="dropdown-item"
                        test-id="action-edit-item">
                      <i aria-hidden="true" class="fa fa-light fa-cog dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.settings' | translate }}</span>
                    </li>
                    <li [routerLink]="[template.id]"
                        class="dropdown-item"
                        test-id="action-modify-template">
                      <i aria-hidden="true" class="fa fa-light fa-file-alt dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.edit' | translate }}</span>
                    </li>
                    <li (click)="openDuplicateETemplateModal(template)" class="dropdown-item"
                        test-id="action-duplicate-template">
                      <i aria-hidden="true" class="fa fa-light fa-copy dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.duplicate' | translate }}</span>
                    </li>
                    <li (click)="openPublishETemplateModal(template)" class="dropdown-item"
                        test-id="action-publish-template">
                      <i aria-hidden="true" class="fa fa-light fa-cloud-upload-alt dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.publish' | translate }}</span>
                    </li>
                    <li (click)="confirmDeleteETemplate(template)" class="dropdown-item text-danger"
                        test-id="action-delete-template">
                      <i aria-hidden="true" class="fa fa-light fa-trash-alt dropdown-icon"></i>
                      <span>{{ 'TEMPLATE.delete' | translate }}</span>
                    </li>
                  </ng-template>
                </ul>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <div *ngIf="!loading && templates?.length === 0" test-id="not-found-message">
        <gp-illustrated-message [text]="'TEMPLATE.no_template_found'" [width]="'50%'"></gp-illustrated-message>
      </div>
    </div>
    <gp-table-pagination
      (pageChange)="refreshTemplates()"
      [pagination]="pagination"
      [text]="'TEMPLATE.showing___of_templates'">
    </gp-table-pagination>
  </div>
</div>

<gp-modal #publishModal [closable]="true"
          class="publish-modal"
          gp-modal="publishModal">
  <div class="gp-modal-title p-x-sm">
    {{ getModalTitle() }}
  </div>
  <form [formGroup]="publishForm" class="gp-modal-body clearfix p-x-sm">
    <div class="row">
      <div class="col-md-12 flex">
        <label class="font-weight-normal m-r-sm">
          {{ getModalConfirmationMessage() }}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 alert alert-info" *ngIf="selectedETemplate?.status != 'PUBLISHED'">
        <em class="fa fa-light fa-info-circle fa-1x text-muted"></em>
        {{ 'TEMPLATE.publish_notification_message' | translate }}
      </div>
      <div class="col-md-12 alert alert-warning" *ngIf="selectedETemplate?.status == 'PUBLISHED'">
        <em class="fa fa-light fa-exclamation-triangle"></em>
        {{ 'TEMPLATE.unpublish_warning_message' | translate }}
      </div>
    </div>
  </form>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="onPublish()"
                class="btn btn-dark p-x-md"
                id="saveBtn"
                type="button">
          {{ 'FORMS.confirm' | translate }}
        </button>
        <button (click)="publishModal.close()" class="btn btn-secondary p-x-md"
                id="cancelBtn"
                type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
